import useLocationService from "hooks/useLocationService";
import { useSession } from "hooks/useSession";
import React, { useState, useEffect } from "react";
import { fetchWrapper } from "utils/apiFetch";
import { showMainToast } from "utils/showToast";
import { captureAvdm } from "utils/rdService";
import { AEPSReceiptModa } from "Settings/Reports/AEPSReceipt";

function AadharpayServicePage() {
    const [showModal, setShowModal] = useState(false);
    const [showMSModal, setShowMSModal] = useState(false);
  const [receiptData, setReceiptData] = useState(null);
  const [pidData, setpidData] = useState("");
  const { location, getLocation } = useLocationService(false);
  const { userid } = useSession();

  const [bankList, setBankList] = useState([]);
  const [selectedBank, setSelectedBank] = useState("");

  const [activeTab, setActiveTab] = useState("details-tab-pane");
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    mobile: "",
    aadhar: "",
    amount: "",
    selectedDevice: "MANTRA",
  });

  const [errors, setErrors] = useState({});

  // ---------------- FP capture ----------------
  const handleCapture = async () => {
    if (loading) return;
    const response = await captureAvdm(formData.selectedDevice, "");
    if (response.success) {
      setpidData(response.data);
    } else {
      alert("Error: " + response.error);
    }
  };

  // ---------------- Tabs ----------------
  const handleTabSwitch = (id) => {
    if (loading) return;
    setActiveTab(id);
  };

  // ---------------- Banks + Geo ----------------
  useEffect(() => {
    getLocation();
    const fetchBankList = async () => {
      try {
        const res = await fetchWrapper("https://pro.mokshiq.in/aeps_bank_list_1");
        const data = res;
        if (data?.data) setBankList(data.data);
      } catch {
        // silent
      }
    };
    fetchBankList();
  }, []);

  // ---------------- Inputs ----------------
  const handleInputChange = (e) => {
    if (loading) return;
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
    if (errors[name]) setErrors((p) => ({ ...p, [name]: "" }));
  };

  // ---------------- Aadhaar format + validate ----------------
  const handleAadharChange = async (e) => {
    if (loading) return;
    const raw = e.target.value.replace(/\D/g, "");
    let formatted = raw;
    if (raw.length > 4) formatted = raw.replace(/(\d{4})(?=\d)/g, "$1-");
    if (raw.length <= 12) setFormData((p) => ({ ...p, aadhar: formatted }));
    if (raw.length === 12) await validateAadhar(raw);
  };

  const validateAadhar = async (aadhaar) => {
    try {
      const fd = new FormData();
      fd.append("aadhar", aadhaar);
      const res = await fetchWrapper("https://pro.mokshiq.in/aadhar_validate", {
        method: "POST",
        body: fd,
      });
      if (!res.status) {
        setErrors((p) => ({ ...p, aadhar: "Aadhaar validation failed" }));
        return false;
      }
      setErrors((p) => ({ ...p, aadhar: "" }));
      return true;
    } catch {
      setErrors((p) => ({ ...p, aadhar: "Aadhaar validation error" }));
      return false;
    }
  };

  // ---------------- Validation ----------------
  const validateForm = () => {
    const e = {};

    if (!formData.mobile) e.mobile = "Mobile number is required";
    else if (!/^[6-9]\d{9}$/.test(formData.mobile)) e.mobile = "Invalid mobile number";

    const a = formData.aadhar.replace(/-/g, "");
    if (!a) e.aadhar = "Aadhaar is required";
    else if (a.length !== 12) e.aadhar = "Enter 12-digit Aadhaar";

    const amt = parseFloat(formData.amount);
    if (!formData.amount) e.amount = "Amount is required";
    else if (amt < 100) e.amount = "Minimum ₹100";
    else if (amt > 10000) e.amount = "Maximum ₹10000";

    if (!selectedBank) e.selectedBank = "Select a bank";
    if (!formData.selectedDevice) e.selectedDevice = "Select a device";
    if (pidData) e.pid = "Scan fingerprint";

    setErrors(e);
    return Object.keys(e).length === 0;
  };
  const handleView = async (refid, tranType = "") => {
    if (!refid || refid === "" || refid === "null" || refid === "undefined") {
      console.warn("No refid found. Receipt will not open.");
      return;
    }
  
    try {
      const url = `https://pro.mokshiq.in/show_receipt_aeps?id=${refid}`;
      const response = await fetchWrapper(url);
  
      if (!response || !response.data) {
        console.error("No receipt data for refid:", refid);
        return;
      }
  
      let finalData = response.data;
  
      // ✅ If MS, use ministatement from MAIN API call (NOT from receipt)
      
    
      
      setReceiptData(finalData);
      setShowModal(true);
  
    } catch (err) {
      console.error("Receipt fetch error:", err);
    }
  };
  // ---------------- Submit ----------------
  const handleSubmit = async (ev) => {
    ev.preventDefault();
    if (!validateForm()) return;

    setLoading(true);

    const fd = new FormData();
    fd.append("userid", userid);
    fd.append("transection_platform", "WEB");
    fd.append("transection_type", "AP"); // Aadhar Pay
    fd.append("lat", location?.lat || "");
    fd.append("long", location?.lng || "");
    fd.append("finger_code", pidData);
    fd.append("number", formData.mobile);
    fd.append("aadhar", formData.aadhar.replace(/-/g, ""));
    fd.append("amount", formData.amount);
    fd.append("bankname", selectedBank);
    fd.append("finger_device", formData.selectedDevice);
    fd.append("device_id", Math.floor(100000 + Math.random() * 900000));

    try {
      const res = await fetchWrapper("https://pro.mokshiq.in/aeps_aadharpay_initiate", {
        method: "POST",
        body: fd,
      });

      if (res.status === true) {
        handleView(res.refid);
        showMainToast(res.data.message || "Transaction Successful!", "success");
      } else {
        handleView(res.refid);
        showMainToast(res.data.message || "Transaction Failed", "danger");
        setpidData(""); // force rescan on fail
      }
    } catch {
      showMainToast("Network Error", "danger");
      setpidData("");
    }

    setLoading(false);
  };

  // ---------------- UI ----------------
  return (
    <main>
      <div className="col-12">
        <div className="block-card-list">
          <div className="card">

            <div className="card-header">
              <h5>AEPS Dashboard</h5>
            </div>

            <div className="card-body" style={{ position: "relative" }}>
              {/* Loader overlay */}
              {loading && (
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    zIndex: 99,
                    background: "rgba(255,255,255,0.6)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img src="../assets/images/loader.gif" alt="loading" style={{ width: 80 }} />
                </div>
              )}

              <div className="nav business-nav d-flex" id="justify-about-tab1" role="tablist">
                <button
                  aria-controls="details-tab-pane"
                  aria-selected={activeTab === "details-tab-pane"}
                  className={`btn nav-link flex-grow-1 text-center ${activeTab === "details-tab-pane" ? "active" : ""}`}
                  onClick={() => handleTabSwitch("details-tab-pane")}
                  type="button"
                  disabled={loading}
                >
                  <span className="f-s-18 f-w-500">Aadhar Pay</span>
                </button>
              </div>

              <div className="tab-content mt-3" id="justify-LightContent1">
                <div className={`tab-pane fade ${activeTab ? "show active" : ""}`} role="tabpanel">
                  <div className="app-form">
                    <div className="row">
                      <div className="col-4">
                        <div className="mb-1">
                          <label className="form-label f-w-500">Customer Mobile</label>
                          <input
                            className={`form-control ${errors.mobile ? "is-invalid" : ""}`}
                            placeholder="Enter mobile number"
                            type="text"
                            name="mobile"
                            value={formData.mobile}
                            onChange={handleInputChange}
                            maxLength="10"
                            disabled={loading}
                          />
                          {errors.mobile && <div className="invalid-feedback">{errors.mobile}</div>}
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="mb-1">
                          <label className="form-label f-w-500">Aadhar Number</label>
                          <input
                            className={`form-control ${errors.aadhar ? "is-invalid" : formData.aadhar.replace(/-/g, "").length === 12 ? "is-valid" : ""}`}
                            placeholder="xxxx-xxxx-xxxx-xxxx"
                            type="text"
                            name="aadhar"
                            value={formData.aadhar}
                            onChange={handleAadharChange}
                            maxLength="19"
                            disabled={loading}
                          />
                          {errors.aadhar && <div className="invalid-feedback">{errors.aadhar}</div>}
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="mb-1">
                          <label className="form-label f-w-500">Amount</label>
                          <input
                            className={`form-control ${errors.amount ? "is-invalid" : ""}`}
                            placeholder="enter amount"
                            type="number"
                            name="amount"
                            value={formData.amount}
                            onChange={handleInputChange}
                            min="1"
                            max="10000"
                            disabled={loading}
                          />
                          {errors.amount && <div className="invalid-feedback">{errors.amount}</div>}
                        </div>
                      </div>
                    </div>

                    {/* Bank selection (unchanged layout) */}
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card">
                          <div className="card-body">

                            {errors.selectedBank && (
                              <div className="text-danger mb-2">{errors.selectedBank}</div>
                            )}

                            <div className="row">
                              <div className="col-sm-6 col-xl-2">
                                <label className="form-checkimage">
                                  <input
                                    className="checkimage-input"
                                    name="fingerprintOption"
                                    type="radio"
                                    value="607027"
                                    checked={selectedBank === "607027"}
                                    onChange={(e) => setSelectedBank(e.target.value)}
                                    disabled={loading}
                                  />
                                  <span className="check-box radiobox">
                                    <img alt="" className="checkbox-image w-100" src="../assets/images/service/punjab.jpg" />
                                  </span>
                                </label>
                              </div>
                              <div className="col-sm-6 col-xl-2">
                                <label className="form-checkimage">
                                  <input
                                    className="checkimage-input"
                                    name="fingerprintOption"
                                    type="radio"
                                    value="607094"
                                    checked={selectedBank === "607094"}
                                    onChange={(e) => setSelectedBank(e.target.value)}
                                    disabled={loading}
                                  />
                                  <span className="check-box radiobox">
                                    <img alt="" className="checkbox-image w-100" src="../assets/images/service/sbi.jpg" />
                                  </span>
                                </label>
                              </div>
                              <div className="col-sm-6 col-xl-2">
                                <label className="form-checkimage">
                                  <input
                                    className="checkimage-input"
                                    name="fingerprintOption"
                                    type="radio"
                                    value="990309"
                                    checked={selectedBank === "990309"}
                                    onChange={(e) => setSelectedBank(e.target.value)}
                                    disabled={loading}
                                  />
                                  <span className="check-box radiobox">
                                    <img alt="" className="checkbox-image w-100" src="../assets/images/service/kotak.png" />
                                  </span>
                                </label>
                              </div>
                              <div className="col-sm-6 col-xl-2">
                                <label className="form-checkimage">
                                  <input
                                    className="checkimage-input"
                                    name="fingerprintOption"
                                    type="radio"
                                    value="606985"
                                    checked={selectedBank === "606985"}
                                    onChange={(e) => setSelectedBank(e.target.value)}
                                    disabled={loading}
                                  />
                                  <span className="check-box radiobox">
                                    <img alt="" className="checkbox-image w-100" src="../assets/images/service/baroda.png" />
                                  </span>
                                </label>
                              </div>

                              <div className="col-md-6 col-xl-4">
                                <div className="mt-4">
                                  <label className="form-label">Select Other Bank</label>
                                  <select
                                    className="form-select"
                                    value={selectedBank}
                                    onChange={(e) => setSelectedBank(e.target.value)}
                                    disabled={loading}
                                  >
                                    <option value="">Select Bank</option>
                                    {bankList.map((bank) => (
                                      <option key={bank.id} value={bank.iinno}>
                                        {bank.bankName}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Device Selection — Option A card style */}
                    <div className="col-md-6 col-xl-12">
                      <div className="card equal-card">
                        <div className="card-body">

                          {errors.selectedDevice && (
                            <div className="text-danger mb-2">{errors.selectedDevice}</div>
                          )}

                          <div className="form-selectgroup">
                            <div className="row g-3">
                              <div className="col-sm-6 col-lg-3">
                                <div className="select-item">
                                  <input
                                    className="form-check-input"
                                    id="MANTRA"
                                    name="deviceOption"
                                    type="radio"
                                    value="MANTRA"
                                    checked={formData.selectedDevice === "MANTRA"}
                                    onChange={(e) =>
                                      setFormData((p) => ({ ...p, selectedDevice: e.target.value }))
                                    }
                                    disabled={loading}
                                  />
                                  <label className="form-check-label" htmlFor="MANTRA">
                                    <span className="d-flex align-items-center">
                                      <img alt="" className="w-30 h-30" src="../assets/images/service/mantra.png" />
                                      <span className="ms-2">
                                        <span className="fs-6">MANTRA</span>
                                        <span className="d-block text-secondary">Select Mantra</span>
                                      </span>
                                    </span>
                                  </label>
                                </div>
                              </div>

                              <div className="col-sm-6 col-lg-3">
                                <div className="select-item">
                                  <input
                                    className="form-check-input"
                                    id="MORPHO"
                                    name="deviceOption"
                                    type="radio"
                                    value="MORPHO"
                                    checked={formData.selectedDevice === "MORPHO"}
                                    onChange={(e) =>
                                      setFormData((p) => ({ ...p, selectedDevice: e.target.value }))
                                    }
                                    disabled={loading}
                                  />
                                  <label className="form-check-label" htmlFor="MORPHO">
                                    <span className="d-flex align-items-center">
                                      <img alt="" className="w-30 h-30" src="../assets/images/service/morpho.jpeg" />
                                      <span className="ms-2">
                                        <span className="fs-6">MORPHO</span>
                                        <span className="d-block text-secondary">Select Morpho</span>
                                      </span>
                                    </span>
                                  </label>
                                </div>
                              </div>

                              <div className="col-sm-6 col-lg-3">
                                <div className="select-item">
                                  <input
                                    className="form-check-input"
                                    id="STARTEK"
                                    name="deviceOption"
                                    type="radio"
                                    value="STARTEK"
                                    checked={formData.selectedDevice === "STARTEK"}
                                    onChange={(e) =>
                                      setFormData((p) => ({ ...p, selectedDevice: e.target.value }))
                                    }
                                    disabled={loading}
                                  />
                                  <label className="form-check-label" htmlFor="STARTEK">
                                    <span className="d-flex align-items-center">
                                      <img alt="" className="w-30 h-30" src="../assets/images/service/startek.jpg" />
                                      <span className="ms-2">
                                        <span className="fs-6">STARTEK</span>
                                        <span className="d-block text-secondary">Select Startek</span>
                                      </span>
                                    </span>
                                  </label>
                                </div>
                              </div>

                              <div className="col-sm-6 col-lg-3">
                                <div className="select-item">
                                  <input
                                    className="form-check-input"
                                    id="EVOLUTE"
                                    name="deviceOption"
                                    type="radio"
                                    value="EVOLUTE"
                                    checked={formData.selectedDevice === "EVOLUTE"}
                                    onChange={(e) =>
                                      setFormData((p) => ({ ...p, selectedDevice: e.target.value }))
                                    }
                                    disabled={loading}
                                  />
                                  <label className="form-check-label" htmlFor="EVOLUTE">
                                    <span className="d-flex align-items-center">
                                      <img alt="" className="w-30 h-30" src="../assets/images/service/evolute.jpg" />
                                      <span className="ms-2">
                                        <span className="fs-6">EVOLUTE</span>
                                        <span className="d-block text-secondary">Select Evolute</span>
                                      </span>
                                    </span>
                                  </label>
                                </div>
                              </div>

                            </div>
                          </div>

                        </div>
                      </div>
                    </div>

                    <label className="check-box">
                      <input type="checkbox" defaultChecked disabled={loading} />
                      <span className="checkmark check-success ms-2"></span>
                      <span className="text-success">
                        I hereby provide my consent to CSP to use my Aadhaar number/ VID to complete AEPS transaction authorisation.
                      </span>
                    </label>

                    {errors.pid && <div className="text-danger mt-2">{errors.pid}</div>}

                    {/* Scan + Submit */}
                    <div className="col-md-6 col-xl-12">
                      <div className="d-flex justify-content-center align-items-center gap-3 flex-wrap">
                        <button
                          onClick={handleCapture}
                          className="btn btn-outline-primary p-0"
                          style={{ width: "80px", height: "80px" }}
                          type="button"
                          disabled={loading}
                        >
                          <img src="../assets/images/service/scan.gif" alt="Gif Button" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                        </button>

                        <div className="col-md-6 col-lg-4 col-12 mt-2">
                          <div className="d-grid gap-2">
                            <button
                              className="btn btn-primary w-100"
                              type="button"
                              onClick={handleSubmit}
                              disabled={loading}
                            >
                              {loading ? "Processing..." : "Aadhar Pay"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>{/* app-form */}
                </div>{/* tab-pane */}
              </div>{/* tab-content */}
            </div>{/* card-body */}

          </div>
        </div>
      </div>
      <AEPSReceiptModa
    receiptData={receiptData}
    isOpen={showModal}
    onClose={() => setShowModal(false)}
    title="Aadhar Pay Receipt"
    logoUrl={"assets/images/logo/2.png"} // You can pass your logo URL here
/>
    </main>
  );
}

export default AadharpayServicePage;
